import React from 'react';
import { MusicClientContext } from '../../context/MusicClientContext';
import { MusicEntity } from '../../types/MusicEntityTypes';
import MusicEditTitlePopupView from './MusicEditTitlePopupView';
import useCustomForm, { validateField } from '../../../common/hooks/CustomForm';
import { FieldValidationErrorsType, showErrorFlush } from '../../../common/form/FrekulForm';

export default function MusicEditTitlePopup({
  music,
  onClose,
  onDone,
  onDelete,
} : {
  music: MusicEntity,
  onClose: () => void,
  onDelete: () => void,
  onDone: () => void,
}) {
  type FieldName = 'title';
  type ValuesType = { [name in FieldName]: string };
  type ErrorsType = { [name in FieldName]?: FieldValidationErrorsType };

  const [values, errors, setValues, setErrors] = useCustomForm<ValuesType, ErrorsType, { name: FieldName }>({
    defaultValue: {
      title: music.title,
    },
    validate(values, options, errors): ErrorsType {
      const name = options.name;
      const value = values[name];
      const error = validateField([
        ['title', 'notEmpty', '曲名を入力してください。', (value) => value.length > 0],
      ], name, value);
      return { ...errors, [name]: error };
    }
  });

  const { saveMusicTitle } = React.useContext(MusicClientContext);

  const handleSubmit = () => {
    saveMusicTitle(music.id, values.title).then((responseData) => {
      if (responseData.result) {
        onDone();
      } else if (responseData.validationErrors) {
        setErrors(responseData.validationErrors);
        showErrorFlush('入力内容に不備があります。');
      }
    });
  };

  return (
    <MusicEditTitlePopupView
      isModified={values.title === music.title}
      onClose={() => onClose()}
      onSave={() => handleSubmit()}
      onDelete={() => onDelete()}
      getValue={(name) => values[name]}
      setValue={(name, value) => setValues({ ...values, [name]: value }, { name })}
      getErrors={(name) => errors?.[name] || {}}
    />
  );
}
